import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Cookies from "universal-cookie";
import axiosHelper from "../../../helpers/axios-helper";
import { getEnumName } from "../../../helpers/enums";
import DisableCheckbox from "../../shared/DisableCheckbox";
import EditDeleteButton from "../../shared/EditDeleteButton";
import Pager from "../../shared/Pager";
import SubContainer from "../../shared/SubContainer";
import SubHeader from "../../shared/SubHeader";

const cookies = new Cookies();

const GameList = (props) => {
  const [gameList, setGameList] = useState();
  useEffect(() => {
    axiosHelper
      .get("/game/get")
      .then((response) => {
        // toast.success("Success");

        setGameList(response.data?.reverse());
      })
      .catch((error) => {
        axiosHelper.handleError(error, "Failed to load games");
      });
  }, []);



  const onDisabledChanged = (id, disabled) => {
    axiosHelper
      .put("/game/changedisabled/" + id, { d: disabled })
      .then((response) => {
        toast.success("Success");
       
        let list = [...gameList];

        list.forEach((i) => {
          if (i._id === id) {
            i.disabled = disabled;
            return false;
          }
        });

        setGameList(list?.reverse());
      })
      .catch((error) => {
        axiosHelper.handleError(error, "Failed to update game status");
      });
  };

  const onClickEditDelete = (type, id) => {


    if (type === "edit") {
      const game = gameList.find((a) => {
        return a._id === id;
      });
      props.selectGame(game);
    } else if (type === "del") {
      axiosHelper
        .put("/game/delete/" + id)
        .then((response) => {
          toast.success("Success");

          const list = gameList.filter((i) => {
            return i._id !== id;
          });

          setGameList(list?.reverse());
        })
        .catch((error) => {
          axiosHelper.handleError(error, "Failed to delete game");
        });
    }
  };

  return (
    <SubContainer>
      <SubHeader
        title="Game List"
        linkTitle="New Game"
        willChangePageMode="save"
        changePageMode={props.changePageMode}
      />
      <table className="table">
        <thead>
          <tr>
            <th>Id</th>
            <th>Name</th>
            <th>Category</th>
            <th>Disabled</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {gameList?.map((item) => {
            return (
              <tr key={item._id}>
                <td>{item._id}</td>
                <td>{item.name}</td>
                <td>
                  {getEnumName(props.enums?.categoryEnum, item.category)}
                </td>
                <td>
                  <DisableCheckbox
                    checked={item.disabled}
                    id={item._id}
                    onChange={onDisabledChanged}
                  />
                </td>
                <td className="text-end">
                  <EditDeleteButton id={item._id} onClick={onClickEditDelete} />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <Pager />
    </SubContainer>
  );
};

export default GameList;
